import React from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { useComposeDescription } from 'hooks/use-compose-description';
import { getDesignToken } from 'styles/constants';
import { CartEntryType } from 'utils/cart/types';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { EntryDescriptionRow, Item, ItemHeader, ItemName, ItemPrice } from './cart-entry.styled';

interface ILegacyCartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
  index?: number;
}

const CartEntry = ({ entry, currencyFormatter }: ILegacyCartEntry) => {
  const quantity = entry.quantity || 1;
  const amount = priceForCartEntry(entry);
  const cartEntryDescription = useComposeDescription(entry, { includeModifiers: true });
  const isOfferDiscount = entry.type === CartEntryType.offerDiscount;
  const shouldShowPrice = entry.price !== null && !isOfferDiscount;

  return (
    <Item accessible focusable>
      <ItemHeader>
        <ItemName>
          {quantity > 1 && `${quantity}x `}
          {entry.name}
        </ItemName>
        <ItemPrice>
          {shouldShowPrice && (
            <Currency
              amount={amount}
              textProps={{
                ...(amount === 0 && { color: getDesignToken('icon-default') }),
                variant: 'headerFour',
                style: { margin: 0 },
                textAlign: 'right',
              }}
            />
          )}
        </ItemPrice>
      </ItemHeader>

      {cartEntryDescription?.length > 0 &&
        cartEntryDescription.map((descriptionItem, index) => (
          <EntryDescriptionRow key={`descriptionItem-${index}`}>
            {descriptionItem}
          </EntryDescriptionRow>
        ))}
    </Item>
  );
};

export default CartEntry;
